<template>
  <div :class="$style.check_wrap">
    <div
      v-if="show_new"
      :class="$style.new">未読</div>
    <div :class="$style.check_list">
      <div :class="$style.check">送信者</div>
      <div :class="[$style.value, $style.type]">
        <p>{{ message_group_data.customer.username }}</p>
      </div>
    </div>
    <div :class="$style.check_list">
      <div :class="$style.check">送信日時</div>
      <div :class="[$style.value, $style.type]">
        <p>{{ formatTimestamp(message_group_data.created_at, 'YYYY/MM/DD（ddd） HH:mm') }}</p>
      </div>
    </div>
    <div :class="$style.check_list">
      <div :class="$style.check">メッセージ</div>
      <div :class="[$style.value, $style.type]" class="n2br">
        <p>{{ message_group_data.messages[0].message }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import cf from '@/mixins/commonFunctions';

export default {
  name: 'CounselorMessageBoxSimple',
  mixins: [
    cf,
  ],
  props: {
    message_group_data: {
      type: Object,
      required: true,
    },
    show_new: {
      type: Boolean,
      default: false,
    },
  },
  created() {
  },
};
</script>

<style lang="scss" module>
.check_wrap {
  position: relative;
  flex-wrap: wrap;
  align-items: center;
  // グレーの枠線、角丸
  border: 3px solid var(--gray-sub);
  border-radius: 8px;
  padding: 12px;

  @include sm-view {
     flex-direction: column;
     align-items: flex-start;
  }
}

.check_list {
  margin-top: 10px;
  display: flex;
  align-items: flex-start;
  // font-size: 14px;
  @include sm-view {
    font-size: 13px;
    display: block;
  }
  @include xs-view {
    display: block;
  }
}

.check {
  background-color: var(--gray-sub);
  font-weight: bold;
  border-radius: 4px;
  padding: 4px 0;
  width: 140px;
  text-align: center;
  margin-right: 12px;
  @include sm-view {
    width: 100%;
    text-align: left;
    padding: 0.5em;
  }
}

.value {
  flex: 1;
  margin-top: 4px;
  // font-weight: bold;

  @include sm-view {
    padding-left: 3%;
  }

  &.type {
    display: flex;
    flex-wrap: wrap;
    p {
      &:not(:last-child) {
        &::after {
          margin: 0 5px;
          content: '/';

        }
      }
    }
  }
}

.new {
  position: absolute;
  top: -10px;
  left: auto;
  right: -8px;
  z-index: 1;
  background-color: var(--pink);
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 4px;

  &_wrap {
    position: relative;
  }

  @include sm-view {
    padding: 3px 7px 2px;
    font-size: 11px;
    right: -4px;
    top: -4px;
  }
}
</style>
